var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 26,
    viewBox: "0 0 16 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7192 29.2257C12.4156 29.2267 12.1156 29.1597 11.8413 29.0296C11.567 28.8995 11.3254 28.7095 11.1341 28.4738L1.31827 16.2802C1.01936 15.9166 0.855957 15.4605 0.855957 14.9897C0.855957 14.519 1.01936 14.0629 1.31827 13.6993L11.4796 1.5057C11.8245 1.09068 12.3202 0.829691 12.8576 0.780145C13.395 0.730599 13.93 0.896557 14.345 1.24151C14.7601 1.58646 15.0211 2.08215 15.0706 2.61954C15.1201 3.15692 14.9542 3.69197 14.6092 4.10699L5.52504 14.9999L14.3044 25.8928C14.5529 26.1911 14.7108 26.5544 14.7593 26.9396C14.8078 27.3248 14.745 27.7158 14.5782 28.0665C14.4115 28.4171 14.1478 28.7126 13.8183 28.918C13.4889 29.1235 13.1075 29.2302 12.7192 29.2257Z",
    fill: "#3F7DBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon);
export default __webpack_public_path__ + "static/media/LeftArrowIcon.9bc79340fcb256366bf8db99ca3ed915.svg";
export { ForwardRef as ReactComponent };